// SEC-M7 phase 10: explicit read allowlist for `family_member_emails` rows.
// Keep in sync with the columns consumed by `dbRowToFamilyMemberEmail` below.
export const FAMILY_MEMBER_EMAIL_COLUMNS =
  'id, family_member_id, team_id, email, user_id, is_primary, created_at';

export interface FamilyMemberEmail {
  id: string;
  familyMemberId: string;
  teamId: string;
  email: string;
  userId: string | null;
  isPrimary: boolean;
  createdAt: Date;
}

export const dbRowToFamilyMemberEmail = (row: any): FamilyMemberEmail => ({
  id: row.id,
  familyMemberId: row.family_member_id,
  teamId: row.team_id,
  email: row.email,
  userId: row.user_id || null,
  isPrimary: row.is_primary ?? false,
  createdAt: new Date(row.created_at),
});
